import React, { useState } from 'react'
import { connect } from 'react-redux'
import { isDirty, submit } from 'redux-form'
import { isEdiVerifiedInsurance } from '../../other/AddOnsHelperFunctions'
import { verifyEDIEligibility } from '../../../../../redux/actions/addOns/EDIClearingHouse/EdiClearningHouseActions'
import { getInsuranceTypeBEName } from '../../../../../itrust_common/components/HelperFunctions'
import { patientLoad } from '../../../../../redux/actions/patient/patientActions'

function EdiVerification(props) {
  const {
    ediClearingHouseConfig,
    services,
    selectedInsuranceName,
    patient,
    selectedInsuranceMemberId,
    insuranceType,
    patientId,
    order,
    currentStoreId,
    isPatientView,
    isPatientFormDirty,
    btnClasses,
  } = props

  const [isVerifying, setIsVerifying] = useState(false)
  const [selectedStaffId, setSelectedStaffId] = useState(null)
  const [selectedServiceCodes, setSelectedServiceCodes] = useState([])

  const isEdiVerified = isEdiVerifiedInsurance(
    ediClearingHouseConfig,
    services,
    selectedInsuranceName
  )

  const dispatch = props.dispatch

  const visionService = services.find((item) =>
    item.config?.vision_insurance_names?.includes(selectedInsuranceName)
  )
  const medicalService = services.find((item) =>
    item.config?.medical_insurance_names?.includes(selectedInsuranceName)
  )
  const service = visionService || medicalService || {}
  const staffs = service.config?.staffs || []

  const serviceOptions = [
    { id: "30", name: "30" },
    { id: "98", name: "98" },
    { id: "AN", name: "AN" },
    { id: "AL", name: "AL" }
  ]

  const toggleSelection = (id) => {
    setSelectedServiceCodes((prev) =>
      prev.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id]
    )
  }

  const handleEdiVerification = (serviceCodes, staffId) => {
    if (isPatientView && isPatientFormDirty) {
      dispatch(submit("patientForm"))
      setTimeout(() => {
        let invalidInputs = document.getElementsByClassName("is-invalid")
        invalidInputs.length === 0 && handleVerify(serviceCodes, staffId)
      }, 500)
    } else {
      handleVerify(serviceCodes, staffId)
    }
  }

  const handleVerify = async (serviceCodes, staffId) => {
    setIsVerifying(true)
    try {
      await dispatch(
        verifyEDIEligibility({
          log: {
            insurance_payer: selectedInsuranceName,
            insurance_type: getInsuranceTypeBEName(insuranceType),
            submitted_type: "verify_eligibility",
            patient_id: patientId,
            store_id:
              currentStoreId ||
              order?.store_id ||
              localStorage.getItem("StoreID"),
            add_ons_id: service.id,
            staff_id: staffId,
            log_type: "eligibility",
            other_details: {
              resource: "verify_eligibility",
              member_id: selectedInsuranceMemberId,
              service_type_code: serviceCodes
            }
          }
        })
      )
    } finally {
      await dispatch(patientLoad(patientId, { include: "*" }))
      setIsVerifying(false)
    }
  }

  return (
    <>
      {isEdiVerified && (
        <div className="dropdown d-flex align-items-center position-relative">
          <button
            className={`btn btn-primary btn-sm ${btnClasses || ''} ${isVerifying ? 'text-nowrap d-flex align-items-center' : 'dropdown-toggle'}`}
            type="button"
            data-toggle={"dropdown"}
            aria-expanded="false"
            disabled={isVerifying}
            onClick={() => setSelectedStaffId(null)}
          >
            {isVerifying ? (
              <>
                <span>Verifying...</span>
                <div className="spinner-border verify-spinner ml-2" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </>
            ) : (
              "Verify"
            )}
          </button>
          <div className="dropdown-menu">
            {!selectedStaffId ? (
              <>
                <h6 className="dropdown-header">Select Staff</h6>
                {staffs.length > 0 ? (
                  staffs.map((staff) => (
                    <span
                      key={staff.id}
                      className="dropdown-item pointer"
                      onClick={(e) => {
                        e.stopPropagation()
                        setSelectedStaffId(staff.id)
                      }}
                    >
                      {staff.name}
                    </span>
                  ))
                ) : (
                  <span className="dropdown-item text-muted">No staff available</span>
                )}
              </>
            ) : (
              <>
                <div className="dropdown-header d-flex align-items-center justify-content-between">
                  <span>Select Service Code</span>
                  <i
                    className="la la-arrow-left pointer"
                    onClick={(e) => {
                      e.stopPropagation()
                      setSelectedStaffId(null)
                    }}
                  />
                </div>
                {serviceOptions.map((item) => (
                  <div
                    key={item.id}
                    className="dropdown-item pointer d-flex align-items-center"
                    onClick={(e) => {
                      e.stopPropagation()
                      toggleSelection(item.id)
                    }}
                  >
                    <input
                      type="checkbox"
                      className="mr-2 pointer"
                      checked={selectedServiceCodes.includes(item.id)}
                      readOnly
                    />
                    <span className="">{item.name}</span>
                  </div>
                ))}
                <div className="dropdown-divider"></div>
                <div className="px-3 pb-2 pt-1 text-center">
                  <button
                    className="btn btn-primary btn-sm w-100"
                    disabled={selectedServiceCodes.length === 0}
                    onClick={(e) => {
                      if (selectedServiceCodes.length > 0) {
                        handleEdiVerification(selectedServiceCodes, selectedStaffId)
                        setSelectedStaffId(null)
                        setSelectedServiceCodes([])
                      } else {
                        e.stopPropagation()
                      }
                    }}
                  >
                    Verify
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  const { organisation: { organisation }, ediClearingHouse: { services }, currentStore: { store }, patient } = state

  return {
    services,
    ediClearingHouseConfig:
      organisation.add_ons_config?.type?.edi_clearing_house,
    currentStoreId: store.id,
    patientId: patient.patient.id,
    patient,
    isPatientFormDirty: isDirty('patientForm')(state),
  }
}

export default connect(mapStateToProps)(EdiVerification)